<template>
  <div>
    <div class="text-center p-16" v-if="isLoadingActiveVenue">
      <p class="opacity-60">Finding setups</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <div
      v-if="!isLoadingActiveVenue"
      class="rounded bg-white p-6 mt-2 drop-shadow"
      style="
        -webkit-box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
      "
    >
      <div class="text-center p-16" v-if="!activeVenueDetails">
        <p>No setups for this venue</p>
        <vs-button
          class="mx-4 mt-2"
          v-if="
            $AuthService.hasPermissionForActiveVenue(
              'vp.vp.booking.createeditsetup'
            )
          "
          @click="$refs.popupAddVenue.show()"
          >Add your first setup</vs-button
        >
      </div>
      <div v-if="activeVenueDetails" class="grid grid-cols-1 tablet:grid-cols-5 gap-0">
        <div class="mb-4 flex flex-col">
          <div
            class="pb-4"
            style="border-bottom: solid 1px lightgray; margin-bottom: 2rem"
          >
            <h5 class="mb-3">Edit setups:</h5>
            <div
              class="setup-item"
              v-bind:class="{
                active: setupIsActive(setupAndCalendarEntryObject.setup),
              }"
              v-for="setupAndCalendarEntryObject of setupsAndCalendarEntries"
              :key="'setup-item-' + setupAndCalendarEntryObject.setup.id"
              @click="selectSetup(setupAndCalendarEntryObject.setup.venueSetupId)"
            >
              <div>
                <p>{{ setupAndCalendarEntryObject.setup.name }}</p>
                <p class="lh-11">
                  <small
                    >Next scheduled:
                    {{
                      getSetupScheduleDate(setupAndCalendarEntryObject.setup)
                        ? getSetupScheduleDate(
                            setupAndCalendarEntryObject.setup
                          ).format("YYYY-MM-DD")
                        : "none"
                    }}</small
                  >
                </p>
              </div>
              <feather-icon
                v-if="setupIsActive(setupAndCalendarEntryObject.setup)"
                icon="ChevronRightIcon"
                class="text-white"
                svgClasses="h-5 w-5"
              ></feather-icon>
            </div>
          </div>

          <vs-button
            class="mx-4 mt-2 max-w-full"
            v-if="
              $AuthService.hasPermissionForActiveVenue(
                'vp.vp.booking.createeditsetup'
              )
            "
            type="border"
            @click="$refs.popupAddSetup.show()"
            >Add setup</vs-button
          >
          <vs-button
            class="mx-4 mt-2 max-w-full"
            type="border"
            @click="$refs.popupScheduleSetup.show()"
            >Schedule setups</vs-button
          >

          <div
            style="
              border-bottom: solid 1px lightgray;
              margin-bottom: 2rem;
              margin-top: 2rem;
            "
          ></div>

          <vs-button
            class="mx-4 max-w-full"
            type="border"
            v-if="
              $AuthService.hasPermissionForActiveVenue(
                'vp.vp.booking.editvenuedetails'
              )
            "
            @click="$refs.popupEditVenue.show(activeVenueDetails)"
            >Edit venue</vs-button
          >

          <vs-button
            class="mx-4 mt-2 max-w-full"
            type="border"
            v-if="
              $AuthService.hasPermissionForActiveVenue(
                'vp.vp.booking.editvenuedetails'
              )
            "
            @click="$refs.popupEditVenueNotes.show(activeVenueDetails)"
            >Add venue note</vs-button
          >

        </div>
        <div
          class="col-span-4 tablet:ml-8 mt-0"
          style="border-left: solid 1px lightgray; "
        >
          <div
            class="ml-8"
            v-if="selectedSetup && selectedSetup.deleted === null"
          >
            <h3 class="text-grey mb-4 mt-4 tablet:mt-0">
              {{ activeVenue.name }}/{{ selectedSetup.name }}
            </h3>
            <vs-row vs-w="12">
              <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
                <p class="text-grey lh-11">Venue policies:</p>
                <show-policies-list :object-with-policies="activeVenueDetails" />
                <p class="text-grey lh-11 mt-2">Setup policies:</p>
                <show-policies-list :object-with-policies="selectedSetup" />
              </vs-col>
              <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                <vs-row vs-w="12" vs-justify="flex-end" class="tablet:mt-0 mt-2">
                  <vs-button
                    v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.handlefloorplan')"
                    class="ml-4 whitespace-nowrap xs:mt-0 mt-2"
                    type="border"
                    @click="$refs.popupEditSetupFloorplan.show(selectedSetup)"
                    >Edit setup floorplan</vs-button
                  >
                  <vs-button
                    v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                    class="ml-4 whitespace-nowrap xs:mt-0 mt-2"
                    type="border"
                    @click="$refs.popupEditSetup.show()"
                    >Edit setup</vs-button
                  >
                </vs-row>
              </vs-col>
            </vs-row>
            <div
              v-for="section of selectedSetup.venueSections.filter(
                (t) => t.deleted === null
              )"
              :key="section.id"
              class="p-4 px-8 mt-4 rounded"
              style="border: solid 1px lightgray"
            >
              <div class="flex justify-between">
                <div class="flex-shrink xxl:w-auto w-full ">
                  <p class="text-grey lh.11">Section policies:</p>
                  <show-policies-list :object-with-policies="section" />
                </div>

                <div class="my-auto xxl:mb-0 mb-4">
                  <vs-button
                    v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.viewevents')"
                    class="ml-4 whitespace-nowrap  xxl:w-auto w-full "
                    type="border"
                    @click="$refs.popupEditEvents.show(activeVenueDetails.id, selectedSetup.id, section)"
                    >Edit events</vs-button
                  >
                  <vs-button
                    v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                    class="ml-4 whitespace-nowrap xxl:mt-0 mt-2 xxl:w-auto w-full"
                    type="border"
                    @click="$refs.popupEditSection.show(section)"
                    >Edit section</vs-button
                  >
                </div>
              </div>
              <h3 class="">
                {{ section.name }}
                <span class="text-grey"
                  >- {{ getSectionTables(section).length }} tables</span
                >
              </h3>
              <vs-collapse class="tables-collapse mt-4">
                <vs-collapse-item :open="true" ref="sectionCollapseItem">
                  <div slot="header">Tables</div>
                  <div ref="sectionCollapseItemContent">
                    <div
                      class="my-4"
                      v-for="table of getSectionTables(section)"
                      :key="table.id"
                    >
                      <h6>
                        {{ table.name }}
                        <span class="text-grey"
                          >- {{ table.seatCount }} seats</span
                        >
                      </h6>
                      <vs-row>
                        <vs-chip v-if="isTableReservedForWalkins(table)" color="primary">Reserved for walk-ins</vs-chip>
                        <vs-chip v-if="!table.isActive"><vs-avatar icon="build" />Not active</vs-chip>
                      </vs-row>
                      <div class="flex">
                        <div>
                          <p class="text-grey lh.11">Table policies:</p>
                          <show-policies-list :object-with-policies="table" />
                        </div>
                        <div v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.handletableactive')"
                          class="ml-16 flex">
                          <vs-switch v-model="table.isActive" class="mr-2" @input="handleTableActiveChanged(selectedSetup, section, table)">
                            <span slot="on">Active</span>
                            <span slot="off">Inactive</span>
                          </vs-switch>
                        </div>
                        <div>
                          <vs-button
                            v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                            class="ml-4 whitespace-nowrap py-1"
                            type="border"
                            size="small"
                            @click="$refs.popupEditTable.show(table, section)"
                            >Edit table</vs-button
                          >
                        </div>
                      </div>
                    </div>
                    <vs-button
                      v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                      class="mt-1 whitespace-nowrap py-1 mb-4"
                      @click="
                        $refs.popupAddTable.show(
                          section,
                          selectedSetup,
                          selectedSetup.venueSections
                        )
                      "
                      type="border"
                      >Add table</vs-button
                    >
                  </div>
                </vs-collapse-item>
              </vs-collapse>

              <vs-collapse
                class="tables-combo-collapse my-6"
              >
                <vs-collapse-item  :open="true">
                  <div slot="header">Table combinations</div>
                  <div>
                    <div
                      class="my-4"
                      v-for="table of getSectionCombinationTables(section)"
                      :key="table.id"
                    >
                      <h6>
                        {{ table.name }}
                        <span class="text-grey"
                          >- {{ table.seatCount }} seats</span
                        >
                      </h6>

                      <div class="flex">
                        <div>
                          <p class="text-grey lh.11">Table policies:</p>
                          <show-policies-list :object-with-policies="table" />
                        </div>
                        <div>
                          <vs-button
                            v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                            class="ml-4 whitespace-nowrap py-1"
                            type="border"
                            size="small"
                            @click="$refs.popupEditTable.show(table, section)"
                            >Edit table</vs-button
                          >
                        </div>
                      </div>
                    </div>
                    <vs-button
                      v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
                      class="mt-1 whitespace-nowrap py-1 mb-4"
                      @click="
                        $refs.popupAddTableCombination.show(
                          section,
                          selectedSetup
                        )
                      "
                      type="border"
                      >Add table combination</vs-button
                    >
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <vs-button
              v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.booking.createeditsetup')"
              class="mt-6"
              type="border"
              @click="$refs.popupAddSection.show(selectedSetup)"
              >Add
              <span v-if="!(selectedSetup.venueSections.length > 0)"
                >your first</span
              >
              section</vs-button
            >
          </div>
        </div>
      </div>
    </div>

    <popup-schedule-setup ref="popupScheduleSetup" />
    <popup-edit-venue
      ref="popupEditVenue"
      :venue-details="activeVenueDetails"
    />
    <popup-add-venue ref="popupAddVenue" />
    <popup-add-setup ref="popupAddSetup" v-if="activeVenueDetails" />
    <popup-add-section
      ref="popupAddSection"
    />
    <popup-add-table ref="popupAddTable" />
    <popup-add-table-combination ref="popupAddTableCombination" />
    <popup-edit-setup
      ref="popupEditSetup"
      :setup="selectedSetup"
    />
    <popup-edit-section
      ref="popupEditSection"
      :setup="selectedSetup"
    />
    <popup-edit-events
      ref="popupEditEvents"
    />
    <popup-edit-table
      ref="popupEditTable"
      :setup="selectedSetup"
    />
    <popup-edit-setup-floorplan ref="popupEditSetupFloorplan" />
    <popup-edit-venue-notes ref="popupEditVenueNotes" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { MUTATIONS as VENUE_MUTATIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import PopupScheduleSetup from "../popups/PopupScheduleSetups.vue";
import PopupEditVenue from "../popups/PopupEditVenue.vue";
import PopupEditEvents from "../popups/PopupEditEvents.vue";
import PopupAddVenue from "../popups/PopupAddVenue.vue";
import PopupAddSetup from "../popups/PopupAddSetup.vue";
import PopupAddSection from "../popups/PopupAddSection.vue";
import PopupAddTable from "../popups/PopupAddTable.vue";
import PopupAddTableCombination from "../popups/PopupAddTableCombination.vue";
import PopupEditSetup from "../popups/PopupEditSetup.vue";
import PopupEditSection from "../popups/PopupEditSection.vue";
import PopupEditTable from "../popups/PopupEditTable.vue";
import PopupEditSetupFloorplan from "../popups/PopupEditSetupFloorplan.vue";
import ShowPoliciesList from "../components/policies/ShowPoliciesList.vue";
import PopupEditVenueNotes from "../popups/PopupEditVenueNotes.vue";
import moment from "moment";

export default {
  components: {
    PopupScheduleSetup,
    PopupEditVenue,
    PopupEditEvents,
    PopupAddVenue,
    PopupAddSetup,
    PopupAddSection,
    PopupAddTable,
    PopupAddTableCombination,
    PopupEditSetup,
    PopupEditSection,
    PopupEditTable,
    PopupEditSetupFloorplan,
    PopupEditVenueNotes,
    ShowPoliciesList,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  updated() {
    const collapseElementsWithMaxHeight = document.getElementsByClassName(
      "vs-collapse-item--content"
    );
    collapseElementsWithMaxHeight.forEach((el) => {
      const childWithContent =
        el.getElementsByClassName("con-content--item")[0];
      if (el.offsetHeight > 0)
        //not collapsed
        el.style.maxHeight = childWithContent.scrollHeight + 200 + "px";
    });
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueDetails: "marcom/activeVenue",
      activeVenueSetups: "marcom/activeVenueSetups",
      isLoadingActiveVenue: "marcom/isLoadingActiveVenue",
      activeVenueSetupCalendarEntries: "marcom/activeVenueSetupCalendarEntries",
      selectedSetup: "marcom/selectedSetup",
    }),
    setupsAndCalendarEntries() {
      return this.activeVenueSetups
        .map((setup) => {
          let calendarEntry = this.activeVenueSetupCalendarEntries.find(
            (ce) => ce.venueSetupId.id === setup.id
          );

          return {
            setup: setup,
            calendarEntry: calendarEntry,
          };
        })
        .sort((a, b) => {
          const aP = a.calendarEntry ? a.calendarEntry.priority : 0;
          const bP = b.calendarEntry ? b.calendarEntry.priority : 0;
          return bP - aP;
        });
    },
  },
  methods: {
    ...mapMutations({
      selectSetup: "marcom/" + VENUE_MUTATIONS.SetSelectedSetup,
    }),
    setupIsActive(setup) {
      return this.selectedSetup && this.selectedSetup.id === setup.id;
    },
    getSetupScheduleDate(setup) {
      const schedule = this.activeVenueSetupCalendarEntries.find(
        (calendarEntry) => calendarEntry.venueSetupId.id === setup.id
      );
      if (schedule && schedule.calendarRepeatInterval) {
        // switch (schedule.calendarRepeatInterval.type) {
        //   case "YearlyRepeatInterval": {
        //     var sorted = schedule.calendarRepeatInterval.repeatOnDates.map(d => new Date(d)).slice().sort((a,b)=>a-b);
        //     return sorted[0];
        //   }
        //   case "WeeklyRepeatInterval": {
        // var today = new Date();
        // var weekdays = [1, 2, 4, 8, 16, 32, 64].map(wd => schedule.calendarRepeatInterval.repeatOnDays & wd).filter(wd => wd > 0).map(wd => Math.log(wd)/Math.log(2) + 1 );
        // var diff = weekdays.map(wd => (wd - today.getDay()) % 7)
        // var nextWeekday = Math.min.apply(Math, diff);
        // return new Date(today.getFullYear(), today.getMonth(), today.getDate() + nextWeekday);
        const now = moment.utc();
        const today = moment.utc([now.year(), now.month(), now.date()]);
        const scheduleDates = schedule.dates.map((d) => moment.utc(d));
        const nextDayIncludingToday = scheduleDates.find((d) => d >= today);
        return nextDayIncludingToday;
        //   }
        //   default:
        //     break;
        // }
      }
      return null;
    },
    getSectionTables(section) {
      return section.venueTables.filter(
        (t) =>
          !t.deleted &&
          (!t.combinationTablePartIds || t.combinationTablePartIds.length === 0)
      );
    },
    getSectionCombinationTables(section) {
      return section.venueTables.filter(
        (t) =>
          !t.deleted &&
          t.combinationTablePartIds &&
          t.combinationTablePartIds.length > 0
      );
    },
    isTableReservedForWalkins(table){
      return table.isReservedForWalkIns();
    },
    async handleTableActiveChanged(setup, section, table) {
      try {
        this.$vs.loading();

        var tableCommand = {
          venueTableId: table.id,
          venueSectionId: section.id,
          venueSetupId: setup.id,
          isActive: table.isActive,
        };

        await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.SetVenueTableActive,
          tableCommand
        );

        this.$vs.notify({
          color: "success",
          title: "Table saved",
          text: "Your table was saved",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Table saved",
          text: "Oops, something went wrong",
        });

        table.isActive = !table.isActive;

      } finally {
        this.$vs.loading.close();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.tables-combo-collapse::v-deep,
.tables-collapse::v-deep {
  &.vs-collapse {
    padding: 0;

    .con-content--item,
    .vs-collapse-item--header {
      padding: 0;
    }
  }
}

.setup-item {
  @apply my-2 p-2 rounded cursor-pointer;
  display: flex;
  justify-content: space-between;
}

.setup-item.active {
  background: linear-gradient(
    18deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  );
  box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.7);
  color: white;
}

.lh-11 {
  line-height: 1.2rem;
}

.whitespace-nowrap {
  white-space: nowrap;
}
</style>
